/**
 * Returns a random integer between min (inclusive) and max (inclusive).
 * The value is no lower than min (or the next integer greater than min
 * if min isn't an integer) and no greater than max (or the next integer
 * lower than max if max isn't an integer).
 * Using Math.round() will give you a non-uniform distribution!
 */
export function getRandomInt(min: number, max: number): number {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * In place array shuffle - mutates the passed in array
 * @param {*} array
 * @returns shuffled array
 */
export function shuffleArray<T>(array: Array<T>) {
    var m = array.length,
        t,
        i;

    // While there remain elements to shuffle…
    while (m) {
        // Pick a remaining element…
        i = Math.floor(Math.random() * m--);

        // And swap it with the current element.
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
}

export function capitalizeFirstLetter<T>(value: string): T {
    return (value.charAt(0).toUpperCase() + value.slice(1)) as T;
}

export function isNumber(value: unknown): boolean {
    return typeof value === 'number';
}

export function padWithLeadingZeros(value: number, totalLength: number = 2) {
    return String(value).padStart(totalLength, '0');
}
